import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import palette from 'lib/styles/palette';

const SubInfoBlock = styled.div`
  margin-top: 5px;

  ${props =>
    props.$hasMarginTop &&
    css`
      margin-top: 1rem;
    `
  }

  color: ${palette.gray[6]};
  
  span + span:before {
    color: ${palette.gray[4]};
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    content: '\\B7';
  }
`;

const Name = styled.label`
  // color: black;
  color: blue;
  font-weight: 600;
  font-size: 18px;
`;

const options = {
  hour12: false,
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
}

const SubInfo = ({ username, publishedDate, hasMarginTop }) => {
  return (
    <div className="SubInfo">
      <SubInfoBlock $hasMarginTop={hasMarginTop}>
        <span>
          <Name>{username}</Name>
        </span>
        <span>
          {new Date(publishedDate).toLocaleString('ko-KR', options)}
        </span>
      </SubInfoBlock>      
    </div>
  );
};

export default SubInfo;